import { Button } from '@/components/ui/button';
import { UserPlus, UserMinus } from 'lucide-react';
import { useFollow } from '@/hooks/useFollow';

interface FollowButtonProps {
  userId: string;
  variant?: 'default' | 'outline';
  size?: 'default' | 'sm' | 'lg';
}

export const FollowButton = ({ userId, variant = 'default', size = 'default' }: FollowButtonProps) => {
  const { isFollowing, loading, toggleFollow } = useFollow(userId);

  return (
    <Button
      variant={isFollowing ? 'outline' : variant}
      size={size}
      onClick={toggleFollow}
      disabled={loading}
      className="rounded-full"
    >
      {isFollowing ? (
        <>
          <UserMinus className="h-4 w-4 mr-2" />
          Unfollow
        </>
      ) : (
        <>
          <UserPlus className="h-4 w-4 mr-2" />
          Follow
        </>
      )}
    </Button>
  );
};
